import emailRegex from "email-regex";

export default function isValidEmail(email) {
    return emailRegex({exact: true}).test(email);
}